<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs required" >{{ $t('counter.counterName') }}</label>
        <input
          v-model="model.counter_name"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('counter_name') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('counter_name')"
        >{{ errors.first('counter_name') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('counter.printerName') }}</label>
        <input
          v-model="model.printer_receipt"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('printer_receipt') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('printer_receipt')"
        >{{ errors.first('printer_receipt') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('counter.ipAddress') }}</label>
        <input
          v-model="model.printer_ip_address"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('printer_ip_address') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('printer_ip_address')"
        >{{ errors.first('printer_ip_address') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('counter.port') }}</label>
        <input
          v-model.number="model.port"
          type="number"
          class="form-control"
          :class="{ 'is-invalid': errors.has('port') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('port')"
        >{{ errors.first('port') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('counter.type') }}</label>
        <select 
          class="form-control" 
          v-model="model.input_type"
          :class="{ 'is-invalid': errors.has('input_type') }"
        >
          <option value="USB">USB</option>
          <option value="NETWORK">NETWORK</option>
        </select>
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('input_type')"
        >{{ errors.first('input_type') }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-mt-3 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{
          $t('cancel')
          }}
        </ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
        >{{ $t('save') }}</ts-button>
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
        >{{ $t('update') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'companyForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      model: {
        counter_id: 0,
        counter_name: null,
        printer_receipt: null,
        printer_ip_address: null,
        port: null,
        input_type: 'NETWORK'
      }
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('counter/setup', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('counter/setup/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('counter/setup/update', {
          id: this.model.counter_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.counter_id = this.edit_data.counter_id
        this.model.counter_name = this.edit_data.counter_name
        this.model.printer_receipt = this.edit_data.printer_receipt
        this.model.printer_ip_address = this.edit_data.printer_ip_address
        this.model.port = this.edit_data.port
        this.model.input_type = this.edit_data.input_type
      }
    }
  }
}
</script>
